import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { CachePolicy } from '@hq/api-sdk';
import { applyThemeCssVars, createTheme, customPaletteFromEnv, mixHex } from '@hq/theme';
import { App as AntdApp, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';

// 自定义配色来自 .env（VITE_CUSTOM_*）；机构级配色登录后再由 sys_org_config 覆盖（DR-11.5）
const theme = createTheme({ mode: 'light', palette: customPaletteFromEnv(import.meta.env) });
applyThemeCssVars(theme);

// 侧边栏：主色加深后混黑，得到品牌深紫底（替换 AntD 默认藏蓝）
const siderBg = mixHex(theme.palette.primaryActive, '#000000', 0.35);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      // 数据变化频率分级见 @hq/api-sdk CachePolicy，页面可按数据类型覆写
      staleTime: CachePolicy.defaultStale,
      gcTime: 5 * 60_000
    }
  }
});

export default function App() {
  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: theme.palette.primary,
          colorLink: theme.palette.primary,
          borderRadius: theme.radius.md,
          colorBgLayout: theme.palette.bgLayout
        },
        components: {
          Layout: { siderBg, headerBg: theme.palette.bgContainer },
          Menu: {
            darkItemBg: siderBg,
            darkPopupBg: siderBg,
            darkSubMenuItemBg: mixHex(siderBg, '#000000', 0.25),
            darkItemSelectedBg: theme.palette.primary
          }
        }
      }}
    >
      <AntdApp>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </AntdApp>
    </ConfigProvider>
  );
}
